import React from 'react';

interface PopupWarningProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const PopupWarning = ({ fill = '#F8BB86', width = 89, height = 88 }: PopupWarningProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 89 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_7_8)">
            <path
                d="M48.1664 66C48.1664 68.0249 46.525 69.6664 44.5 69.6664C42.475 69.6664 40.8336 68.025 40.8336 66C40.8336 63.975 42.475 62.3336 44.5 62.3336C46.525 62.3336 48.1664 63.975 48.1664 66ZM44.5 55C42.982 55 41.75 53.768 41.75 52.25V21.0836C41.75 19.5656 42.982 18.3336 44.5 18.3336C46.018 18.3336 47.25 19.5656 47.25 21.0836V52.25C47.25 53.768 46.018 55 44.5 55Z"
                fill={fill}
            />
            <path
                d="M44.5 88C20.2374 88 0.5 68.2626 0.5 44C0.5 19.7374 20.2374 0 44.5 0C68.7626 0 88.5 19.7374 88.5 44C88.5 68.2626 68.7626 88 44.5 88ZM44.5 5.5C23.27 5.5 6 22.77 6 44C6 65.23 23.27 82.5 44.5 82.5C65.73 82.5 83 65.23 83 44C83 22.77 65.73 5.5 44.5 5.5Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_7_8">
                <rect width="88" height="88" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
);
